import { type Dispatch, type SetStateAction } from "react";

interface ToggleButtonProps {
  isExpand: boolean;
  setIsExpand: Dispatch<SetStateAction<boolean>>;
}

export default function ToggleButton({
  setIsExpand,
  isExpand,
}: ToggleButtonProps) {
  const handleClick = () => {
    setIsExpand((prev) => !prev);
  };

  return (
    <button
      onClick={handleClick}
      className="size-10 rounded-full  flex items-center justify-center"
    >
      <img
        src={
          !isExpand
            ? "https://api.iconify.design/mdi:menu.svg"
            : "/images/closeicon.png"
        }
        height={20}
        width={20}
      />
    </button>
  );
}
